/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Avatar, Pressable } from '@components/atoms'
import { Menu, MenuItem as MuiMenuItem } from '@mui/material'

import {
	useAppSelector,
	useAppDispatch,
	authActions,
	ConfigStateType,
} from '@redux/index'
import { UserType } from '@schemas'
import { blueGrey } from '@mui/material/colors'
import { useNavigate } from 'react-router-dom'

export const LogedInUserInfo = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// hook
	const navigate = useNavigate()

	// redux state
	const mode: ConfigStateType['mode'] = useAppSelector(state => state.config.mode)
	const user: UserType = useAppSelector(state => state.user.user)
	const isOpenDrawer: boolean = useAppSelector(state => state.config.isOpenDrawer)
	const isMobile: boolean = useAppSelector(state => state.config.isMobile)

	// state
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

	// variables
	const open = Boolean(anchorEl)

	const onOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const onCloseMenu = React.useCallback(() => {
		setAnchorEl(null)
	}, [])

	const onTurnOffAdminMode = React.useCallback(() => {
		onCloseMenu()
		// reduxDispatch(adminActions.TRIGGER_LEAVE_TO_ADMIN(true))
	}, [])

	const onAdminClick = React.useCallback(() => {
		onCloseMenu()
		// reduxDispatch(adminActions.TRIGGER_GO_TO_ADMIN(true))
	}, [])

	const onLogoutClick = React.useCallback(() => {
		onCloseMenu()
		reduxDispatch(authActions.TRIGGER_LOGOUT(true))
	}, [])

	const onGoHomeButton = React.useCallback(() => {
		onCloseMenu()
		navigate('/main/home')
	}, [])

	const MenuItem = ({ name, onClick }: { name: string; onClick: () => void }) => {
		return (
			<MuiMenuItem css={{ minWidth: '10rem', height: '2rem' }} onClick={onClick}>
				<Text category="p2">{name}</Text>
			</MuiMenuItem>
		)
	}

	return (
		<View css={style}>
			<Pressable
				className="userInfoButton"
				id="userInfoButton"
				aria-controls={open ? 'userInfoMenu' : undefined}
				aria-haspopup="true"
				aria-expanded={open ? 'true' : undefined}
				onClick={onOpenMenu}
			>
				<Avatar
					className="userInfoAvatar"
					picture={user.profileImageUrl}
					name={user.name}
					color={user.profileColor === '' ? blueGrey[100] : user.profileColor}
					extpandingDisable={true}
				/>
				{isOpenDrawer ? <Text className="userName">{user.name}</Text> : null}
			</Pressable>

			<Menu
				id="userInfoMenu"
				anchorEl={anchorEl}
				open={open}
				onClose={onCloseMenu}
				MenuListProps={{
					'aria-labelledby': 'userInfoButton',
				}}
			>
				{!isMobile ? (
					<View>
						<MenuItem name="로그아웃" onClick={onLogoutClick} />

						<View>
							{mode === 'admin' ? (
								<MenuItem
									name="관리자 설정 나가기"
									onClick={() => onTurnOffAdminMode()}
								/>
							) : (
								<MenuItem name="관리자 설정" onClick={() => onAdminClick()} />
							)}
						</View>
					</View>
				) : (
					<View>
						<MenuItem name="홈으로 가기" onClick={onGoHomeButton} />
						<MenuItem name="로그아웃" onClick={onLogoutClick} />
					</View>
				)}
			</Menu>
		</View>
	)
}

const style = css({
	width: '100%',

	'.userInfoButton': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',

		'.userInfoAvatar': {
			width: '2.3rem',
			height: '2.3rem',
		},

		'.userName': {
			marginLeft: '0.5rem',
		},
	},
})
